export default __webpack_public_path__ + "static/media/ms-teams.399c8b5a.svg";